import { useLazyQuery, useMutation } from "@apollo/client";
import { useAuth } from "components/custom/authprovider";
import { GET_ADMINCUSTOMER_DETAILS } from "graphql/admin/mutations/customers";
import { SET_ADMINCUSTOMER_PLAID_VERIFY } from "graphql/admin/mutations/customers";
import { UPDATE_ADMINCUSTOMER_NOTES } from "graphql/admin/mutations/customers";
import { CREATE_LOCK_NOTE } from "graphql/admin/mutations/locknotes";
import { GET_ALL_DISPUTED_TRANSACTIONS } from "graphql/admin/mutations/transactions";
import { GET_ALL_DISPUTED_TRANSACTIONS_BY_CUSTOMER_ID } from "graphql/admin/mutations/transactions";
import { GET_LAST_LOCK_NOTE_BY_CUSTOMER_ID } from "graphql/admin/queries/locknotes";
import { GET_ADMIN_GET_DISPUTED_TRANSACTION_REPORT } from "graphql/admin/queries/transactions";
import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Select from "react-select";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
} from "reactstrap";
import { formatDateLongFormat } from "utils/date";
import { formatDate } from "utils/date";
import { SAlert } from "utils/functions";
import { SimpleFormatPhone } from "utils/functions";
import { SADropdownOrOther } from "utils/functions";
import sendMutationContext from "utils/sendContext";
import {
  GET_CUSTOMER_BY_ID,
  GET_DISPUTED_CUSTOMER_PHONE_NUMBERS,
} from "../../graphql/admin/queries/customers";
import AdminNav from "./AdminNav";
import CustomerCard from "./components/customer";
import XTable from "./components/table";
import { mkConfig, generateCsv, download } from "export-to-csv";
import { formatDateMDYString } from "utils/date";

function TransactionDisputeLookup() {
  const { wt } = useAuth();
  const { cphone } = useParams();
  const [inputPhone, setInputPhone] = useState("");
  const history = useHistory();
  const [logoutFlag, setLogoutFlag] = useState(false);

  const location = useLocation();
  const initialPathRef = useRef(location.pathname);
  const basePath = (() => {
    const current = initialPathRef.current;
    const lastSlashIndex = current.lastIndexOf("/");

    if (
      current.slice(lastSlashIndex, current.length) ==
      "/transaction-dispute-lookup"
    ) {
      return current + "/";
    }

    return current.slice(0, lastSlashIndex + 1);
  })();

  const [phone, setPhone] = useState("");
  const [currentView, setCurrentView] = useState("disputeDateReport");

  const [customer, setCustomer] = useState(null);
  const [getCustomerById] = useLazyQuery(
    GET_CUSTOMER_BY_ID,
    sendMutationContext(wt, setLogoutFlag)
  );

  const [customerPhoneData, setCustomerPhoneData] = useState([]);
  const [getDisputedCustomerPhoneNumbers] = useLazyQuery(
    GET_DISPUTED_CUSTOMER_PHONE_NUMBERS,
    sendMutationContext(wt, setLogoutFlag)
  );

  const [disputedTransactionsOptions, setDisputedTransactionsOptions] =
    useState({ limit: 50 });
  const [allDisputedTransactions, setAllDisputedTransactions] = useState([]);
  const [adminGetAllDisputedTransactions] = useLazyQuery(
    GET_ALL_DISPUTED_TRANSACTIONS,
    sendMutationContext(wt, setLogoutFlag)
  );

  const [disputedReportOptions, setDisputedReportOptions] = useState({
    dateDisputedStartRange: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    ).toString(),
    dateDisputedEndRange: new Date(
      new Date().getFullYear(),
      new Date().getMonth() + 1,
      0
    ).toString(),
    limit: 0,
  });
  const [disputedRangeStart, setDisputedRangeStart] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1)
  );
  const [disputedRangeEnd, setDisputedRangeEnd] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
  );
  const [disputedDistributorReport, setDisputedDistributorReport] = useState(
    []
  );
  const [disputedCustomerReport, setDisputedCustomerReport] = useState([]);
  const [disputedCustomerNumOfDisputes, setDisputedCustomerNumOfDisputes] =
    useState(0);
  const [
    disputedCustomerTotalDisputedAmount,
    setDisputedCustomerTotalDisputedAmount,
  ] = useState(0);
  const [
    disputedDistributorNumOfDisputes,
    setDisputedDistributorNumOfDisputes,
  ] = useState(0);
  const [
    disputedDistributorTotalDisputedAmount,
    setDisputedDistributorTotalDisputedAmount,
  ] = useState(0);
  const [
    disputedDistributorNumOfWonDisputes,
    setDisputedDistributorNumOfWonDisputes,
  ] = useState(0);
  const [
    disputedDistributorTotalWonDisputedAmount,
    setDisputedDistributorTotalWonDisputedAmount,
  ] = useState(0);
  const [
    disputedDistributorNumOfLostDisputes,
    setDisputedDistributorNumOfLostDisputes,
  ] = useState(0);
  const [
    disputedDistributorTotalLostDisputedAmount,
    setDisputedDistributorTotalLostDisputedAmount,
  ] = useState(0);
  const [adminGetDisputedTransactionReport] = useLazyQuery(
    GET_ADMIN_GET_DISPUTED_TRANSACTION_REPORT,
    sendMutationContext(wt, setLogoutFlag)
  );

  const [transactions, setTransactions] = useState({});
  const [adminGetDisputedTransactions] = useLazyQuery(
    GET_ALL_DISPUTED_TRANSACTIONS_BY_CUSTOMER_ID,
    sendMutationContext(wt, setLogoutFlag)
  );
  const [adminCustomerLookup] = useMutation(
    GET_ADMINCUSTOMER_DETAILS,
    sendMutationContext(wt, setLogoutFlag)
  );

  const [adminCreateLockNote] = useMutation(
    CREATE_LOCK_NOTE,
    sendMutationContext(wt, setLogoutFlag)
  );
  const [adminGetLastLockNoteByCustomerId] = useLazyQuery(
    GET_LAST_LOCK_NOTE_BY_CUSTOMER_ID,
    sendMutationContext(wt, setLogoutFlag)
  );
  const [adminCustomerSetPlaidVerifyById] = useMutation(
    SET_ADMINCUSTOMER_PLAID_VERIFY,
    sendMutationContext(wt, setLogoutFlag)
  );
  const [updateCustomerNotes] = useMutation(
    UPDATE_ADMINCUSTOMER_NOTES,
    sendMutationContext(wt, setLogoutFlag)
  );

  const [dropdownLatestOpen, setDropdownLatestOpen] = useState(false);
  const toggle = () => {
    setDropdownLatestOpen((prevState) => !prevState);
  };

  const [dropdownViewOpen, setDropdownViewOpen] = useState(false);
  const toggleView = () => {
    setDropdownViewOpen((prevState) => !prevState);
  };

  const customSelectStyle = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      borderColor: state.isFocused ? "blue" : "gray",
      boxShadow: state.isFocused ? "0 0 5px rgba(0, 0, 255, 0.5)" : "none",
      "&:hover": {
        borderColor: "blue",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "lightblue"
        : state.isFocused
        ? "lightblue"
        : "white",
      color: state.isSelected ? "white" : "black",
      "&:hover": {
        backgroundColor: "lightblue",
      },
    }),
  };

  const getAllDisputedTransactions = async () => {
    adminGetAllDisputedTransactions({
      variables: disputedTransactionsOptions,
    }).then((res) => {
      const status = res.data.adminGetAllDisputedTransactions.status ?? false;

      if (status) {
        setAllDisputedTransactions(
          res.data.adminGetAllDisputedTransactions.transactions
            .slice()
            .sort((a, b) => a.datetimedisputed < b.datetimedisputed)
        );
      }
    });
  };

  const getDisputedReport = async () => {
    adminGetDisputedTransactionReport({
      variables: disputedReportOptions,
    }).then((res) => {
      const status = res.data.getDisputedTransactionReport.status ?? false;
      console.log(res.data);

      if (status) {
        const data = res.data.getDisputedTransactionReport;

        setDisputedDistributorReport(
          data.distributors
            .slice()
            .sort((a, b) => a.referenceid1 < b.referenceid1)
        );
        setDisputedCustomerReport(
          data.customers.slice().sort((a, b) => a.referenceid1 < b.referenceid1)
        );
        setDisputedCustomerNumOfDisputes(data.customerNumOfDisputes);
        setDisputedCustomerTotalDisputedAmount(
          data.customerTotalDisputedAmount
        );
        setDisputedDistributorNumOfDisputes(data.distributorNumOfDisputes);
        setDisputedDistributorTotalDisputedAmount(
          data.distributorTotalDisputedAmount
        );

        setDisputedDistributorNumOfLostDisputes(
          data.distributorNumOfLostDisputes
        );
        setDisputedDistributorTotalLostDisputedAmount(
          data.distributorTotalLostDisputedAmount
        );

        setDisputedDistributorNumOfWonDisputes(
          data.distributorNumOfWonDisputes
        );
        setDisputedDistributorTotalWonDisputedAmount(
          data.distributorTotalWonDisputedAmount
        );
      } else {
        setDisputedDistributorReport([]);
        setDisputedCustomerReport([]);
        setDisputedCustomerNumOfDisputes(0);
        setDisputedCustomerTotalDisputedAmount(0);
        setDisputedDistributorNumOfDisputes(0);
        setDisputedDistributorTotalDisputedAmount(0);
        setDisputedDistributorNumOfWonDisputes(0);
        setDisputedDistributorTotalWonDisputedAmount(0);
        setDisputedDistributorNumOfLostDisputes(0);
        setDisputedDistributorTotalLostDisputedAmount(0);
      }
    });
  };

  const setCustomerPlaidVerify = async (customerId) => {
    const req = await adminCustomerSetPlaidVerifyById({
      variables: { id: customerId },
    });

    if (req && req.data && req.data.adminCustomerSetPlaidVerifyById) {
      const status = req.data.adminCustomerSetPlaidVerifyById.status;

      if (status) {
        if (customer.plaidverified) {
          customer.plaidverified = false;
        } else {
          customer.plaidverified = true;
        }

        setCustomer(customer);
      }
    }
  };

  const lockNote = (customer) => {
    const title = customer.isEnabled ? "Lock" : "Unlock";
    const options = {
      other: "Other",
    };

    SADropdownOrOther(
      `${title} Note`,
      "Select the reason for the lock note",
      "Confirm",
      options
    ).then((value) => {
      if (value) {
        adminCreateLockNote({
          variables: {
            reason: options[value] ?? value,
            customerid: customer.customerid,
          },
        })
          .then((res) => {
            const status = res?.data?.createLockNote?.status ?? false;

            if (status) {
              setCustomer((prevCustomer) => {
                return {
                  ...prevCustomer,
                  active: !prevCustomer.active,
                  isEnabled: !prevCustomer.isEnabled,
                  locknote: res.data.createLockNote.locknote.reason,
                  islock: res.data.createLockNote.locknote.islock,
                };
              });
            } else {
              SAlert(
                "Error",
                "There was an error creating the lock note. Please try again.",
                "error"
              );
            }
          })
          .catch(() => {
            SAlert(
              "Error",
              "An error occurred while processing the request. Please try again.",
              "error"
            );
          });
      }
    });
  };

  const updateDisputedCustomerList = () => {
    getDisputedCustomerPhoneNumbers().then((res) => {
      setCustomerPhoneData(() => {
        const customers = (
          res?.data?.adminGetDisputedCustomerPhoneNumbers?.customers ?? []
        )
          .slice()
          .filter((fCustomer) => {
            // Lazy way of dealing with a re-render issue...
            if (customer && fCustomer.customerid === customer.customerid) {
              return customer.active;
            }

            return true;
          })
          .sort((a, b) => (a.lastname || "").localeCompare(b.lastname || ""))
          .map((item) => ({
            value: item.customerid,
            label: `${item.phone} - ${item.firstname || ""} ${item.lastname}`,
          }));

        return customers;
      });
    });
  };

  const listHeader = [
    {
      Header: "Transaction ID",
      accessor: "ctransid",
      className: "t-cell-3 text-centered mwTable-15",
      disableFilters: true,
      disableSortBy: true,
      notShowSortingDisplay: true,
      Cell: (props) => {
        return (
          <span>
            <a
              href={"/admin/tools/transaction-lookup/" + props.value}
              className="link bold"
            >
              {props.value}
            </a>
          </span>
        );
      },
    },
    {
      Header: "Gateway",
      accessor: "gateway",
      className: "t-cell-3 text-centered mwTable-15",
      disableFilters: true,
      disableSortBy: true,
      notShowSortingDisplay: true,
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Status",
      accessor: "disputestatus",
      className: "t-cell-3 text-centered mwTable-15",
      disableFilters: true,
      disableSortBy: true,
      notShowSortingDisplay: true,
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Reason",
      accessor: "disputereason",
      className: "t-cell-3 text-centered mwTable-15",
      disableFilters: true,
      disableSortBy: true,
      notShowSortingDisplay: true,
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "User",
      accessor: "disputeinitiatedby",
      className: "t-cell-3 text-centered mwTable-15",
      disableFilters: true,
      disableSortBy: true,
      notShowSortingDisplay: true,
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "DateTime",
      accessor: "datetimedisputed",
      className: "t-cell-3 text-centered mwTable-10",
      disableFilters: true,
      disableSortBy: true,
      notShowSortingDisplay: true,
      Cell: (props) => <span>{formatDate(props.value)}</span>,
    },
  ];

  useEffect(() => {
    if (cphone) {
      setPhone(cphone);
    }

    updateDisputedCustomerList();
    getAllDisputedTransactions();
    getDisputedReport();
  }, []);

  useEffect(() => {
    setDisputedReportOptions((prevState) => {
      const obj = {};

      if (disputedRangeStart) {
        // obj.dateDisputedStartRange = new Date(disputedRangeStart.getFullYear(), disputedRangeStart.getMonth(), disputedRangeStart.getDate()).toString();
        obj.dateDisputedStartRange = new Date(disputedRangeStart).toString();
      } else {
        obj.dateDisputedStartRange = null;
      }

      if (disputedRangeEnd) {
        // obj.dateDisputedEndRange = new Date(disputedRangeEnd.getFullYear(), disputedRangeEnd.getMonth(), disputedRangeEnd.getDate()).toString();
        obj.dateDisputedEndRange = new Date(disputedRangeEnd).toString();
      } else {
        obj.dateDisputedEndRange = null;
      }

      return {
        ...prevState,
        ...obj,
      };
    });
  }, [disputedRangeStart, disputedRangeEnd]);

  useEffect(() => {
    getDisputedReport();
  }, [disputedReportOptions]);

  useEffect(() => {
    getAllDisputedTransactions();
  }, [disputedTransactionsOptions]);

  useEffect(() => {
    getDisputedReport();
  }, [disputedReportOptions]);

  useEffect(() => {
    if (phone) {
      history.replace({ pathname: basePath + phone });
      return;
    }

    history.replace({ pathname: basePath });
  }, [phone]);

  useEffect(() => {
    if (phone) {
      adminCustomerLookup({
        variables: {
          phone: phone,
        },
      }).then((res) => {
        if (res?.data?.adminCustomerLookup?.customer) {
          const data = res.data.adminCustomerLookup.customer;

          adminGetLastLockNoteByCustomerId({
            variables: {
              customerid: data.customerid,
            },
          }).then((res) => {
            const status =
              res?.data?.getLastLockNoteByCustomerId?.status ?? false;
            const customer = {
              customerid: data.customerid,
              firstname: data.firstname,
              lastname: data.lastname,
              address1: data.address1,
              address2: data.address2,
              city: data.city,
              state: data.state,
              zip: data.zip,
              phone: data.phone,
              email: data.email,
              country: data.country,
              gender: data.gender,
              datetimecreated: data.datetimecreated,
              datetimeupdated: data.datetimeupdated,
              birthdate: data.birthdate,
              active: data.isEnabled,
              isEnabled: data.isEnabled,
              plaidverified: data.plaidverified,
            };

            if (status) {
              customer.locknote =
                res.data.getLastLockNoteByCustomerId.locknote.reason;
              customer.islock =
                res.data.getLastLockNoteByCustomerId.locknote.islock;
            }

            setCustomer(customer);
          });

          adminGetDisputedTransactions({
            variables: {
              customerid: data.customerid,
            },
          }).then((res) => {
            const status =
              res?.data?.adminGetAllDisputedTransactionsByCustomerId?.status ??
              false;

            if (status) {
              setTransactions(
                res.data.adminGetAllDisputedTransactionsByCustomerId.transactions
                  .slice()
                  .sort((a, b) => a.datetimedisputed < b.datetimedisputed)
              );
            }
          });
        }
      });
    }
  }, [phone, customerPhoneData]);

  useEffect(() => {
    if (logoutFlag) {
      history.push("/admin/logout");
    }
  }, [logoutFlag]);

  return (
    <div className="admin-wrapper">
      <AdminNav />

      <Container fluid className="content">
        <Row>
          <Col md="12">
            <Card className="card-dark">
              <CardHeader>
                <Row>
                  <Col sm={customer ? "7" : "9"}>
                    Transaction Dispute Lookup
                  </Col>

                  <Col sm={customer ? "5" : "3"} style={{ textAlign: "right" }}>
                    {customerPhoneData && (
                      <Row>
                        {customer && (
                          <Col sm="4">
                            <Button
                              onClick={() => {
                                setPhone("");
                                setInputPhone("");
                                setCustomer(null);
                                history.replace({ pathname: basePath });
                              }}
                            >
                              Clear Search
                            </Button>
                          </Col>
                        )}

                        <Col
                          sm={customer ? "8" : "12"}
                          style={{ textAlign: "right" }}
                        >
                          <Select
                            options={customerPhoneData}
                            inputValue={inputPhone}
                            styles={customSelectStyle}
                            onInputChange={(e) => {
                              if (e.length >= 3 && !isNaN(parseInt(e, 10))) {
                                setInputPhone(SimpleFormatPhone(e));
                                return;
                              }

                              setInputPhone(e);
                            }}
                            onChange={(e) => {
                              getCustomerById({
                                variables: {
                                  customerid: e.value,
                                },
                              }).then((res) => {
                                if (res?.data?.adminGetCustomerById?.customer) {
                                  const data =
                                    res.data.adminGetCustomerById.customer;

                                  adminGetLastLockNoteByCustomerId({
                                    variables: {
                                      customerid: data.customerid,
                                    },
                                  }).then((res) => {
                                    const status =
                                      res?.data?.getLastLockNoteByCustomerId
                                        ?.status ?? false;
                                    const customer = {
                                      customerid: data.customerid,
                                      firstname: data.firstname,
                                      lastname: data.lastname,
                                      address1: data.address1,
                                      address2: data.address2,
                                      city: data.city,
                                      state: data.state,
                                      zip: data.zip,
                                      phone: data.phone,
                                      email: data.email,
                                      country: data.country,
                                      gender: data.gender,
                                      datetimecreated: data.datetimecreated,
                                      datetimeupdated: data.datetimeupdated,
                                      birthdate: data.birthdate,
                                      active: data.active,
                                      isEnabled: data.active,
                                      plaidverified: data.plaidverified,
                                    };

                                    if (status) {
                                      customer.locknote =
                                        res.data.getLastLockNoteByCustomerId.locknote.reason;
                                      customer.islock =
                                        res.data.getLastLockNoteByCustomerId.locknote.islock;
                                    }

                                    setCustomer(customer);

                                    history.replace({
                                      pathname: basePath + customer.phone,
                                    });
                                  });

                                  adminGetDisputedTransactions({
                                    variables: {
                                      customerid: data.customerid,
                                    },
                                  }).then((res) => {
                                    const status =
                                      res?.data
                                        ?.adminGetAllDisputedTransactionsByCustomerId
                                        ?.status ?? false;

                                    if (status) {
                                      setTransactions(
                                        res.data.adminGetAllDisputedTransactionsByCustomerId.transactions
                                          .slice()
                                          .sort(
                                            (a, b) =>
                                              a.datetimedisputed <
                                              b.datetimedisputed
                                          )
                                      );
                                    }
                                  });
                                }
                              });
                            }}
                            isSearchable={true}
                            placeholder="Customer search..."
                          />
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                {!customer && (
                  <Row className="pb-2">
                    <Dropdown isOpen={dropdownViewOpen} toggle={toggleView}>
                      <DropdownToggle>
                        {"View "}
                        {dropdownViewOpen ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-caret-up-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-caret-down-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                          </svg>
                        )}
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem
                          value="Dispute Date Report"
                          onClick={() => {
                            setCurrentView("disputeDateReport");
                          }}
                        >
                          Dispute Date Report
                        </DropdownItem>
                        <DropdownItem
                          value="Latest Disputed Transactions"
                          onClick={() => {
                            setCurrentView("latestDisputedTransactions");
                          }}
                        >
                          Latest Disputed Transactions
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </Row>
                )}

                {!customer && currentView === "disputeDateReport" && (
                  <>
                    <Row>
                      <Button
                        onClick={() => {
                          const csvConfig = mkConfig({
                            useKeysAsHeaders: false,
                            showTitle: true,
                            title: `"Date Range: ${formatDateLongFormat(
                              new Date(disputedRangeStart)
                            )} - ${formatDateLongFormat(
                              new Date(disputedRangeEnd)
                            )}"`,
                          });

                          csvConfig.filename = `${formatDateMDYString(
                            new Date()
                          )} - Disputed Distributor Report`;
                          csvConfig.columnHeaders = [
                            {
                              key: "referenceid1",
                              displayLabel: "Distributor",
                            },
                            {
                              key: "numOfDisputes",
                              displayLabel: "# of Disputes",
                            },
                            {
                              key: "totalDisputedAmount",
                              displayLabel: "Total Disputed",
                            }, //
                            {
                              key: "numOfDisputesWon",
                              displayLabel: "Disputes Won",
                            },
                            {
                              key: "totalDisputedAmountWon",
                              displayLabel: "Disputes Won Total",
                            },
                            {
                              key: "numOfDisputesLost",
                              displayLabel: "Disputes Lost",
                            },
                            {
                              key: "totalDisputedAmountLost",
                              displayLabel: "Disputes Lost Total",
                            },
                          ];
                          const csvDistributor = generateCsv(csvConfig)([
                            ...disputedDistributorReport,
                            {},
                            {
                              referenceid1: "Total",
                              numOfDisputes: disputedDistributorNumOfDisputes,
                              totalDisputedAmount:
                                disputedDistributorTotalDisputedAmount,
                              totalDisputedAmountWon:
                                disputedDistributorTotalWonDisputedAmount,
                              numOfDisputesWon:
                                disputedDistributorNumOfWonDisputes,
                              totalDisputedAmountLost:
                                disputedDistributorTotalLostDisputedAmount,
                              numOfDisputesLost:
                                disputedDistributorNumOfLostDisputes,
                            },
                          ]);
                          download(csvConfig)(csvDistributor);

                          csvConfig.columnHeaders = [
                            {
                              key: "referenceid1",
                              displayLabel: "Distributor",
                            },
                            {
                              key: "firstname",
                              displayLabel: "First Name",
                            },
                            {
                              key: "lastname",
                              displayLabel: "Last Name",
                            },
                            {
                              key: "phone",
                              displayLabel: "Phone",
                            },
                            {
                              key: "numOfDisputes",
                              displayLabel: "# of Disputes",
                            },
                            {
                              key: "totalDisputedAmount",
                              displayLabel: "Total Disputed",
                            },
                          ];
                          csvConfig.filename = `${formatDateMDYString(
                            new Date()
                          )} - Disputed Customer Report`;
                          const csvCustomer = generateCsv(csvConfig)([
                            ...disputedCustomerReport,
                            {},
                            {
                              referenceid1: "Total",
                              numOfDisputes: disputedDistributorNumOfDisputes,
                              totalDisputedAmount:
                                disputedDistributorTotalDisputedAmount,
                            },
                          ]);
                          download(csvConfig)(csvCustomer);
                        }}
                      >
                        Download
                      </Button>
                    </Row>
                    <Row className="p-2">
                      <Col className="text-center">
                        Current Range Start:{" "}
                        {formatDateLongFormat(
                          new Date(disputedReportOptions.dateDisputedStartRange)
                        )}
                      </Col>
                      <Col className="text-center">
                        Current Range End:{" "}
                        {formatDateLongFormat(
                          new Date(disputedReportOptions.dateDisputedEndRange)
                        )}
                      </Col>
                    </Row>
                    <Row className="p-2">
                      <Col className="text-center">
                        Dispute Range Start:{" "}
                        <input
                          type="date"
                          onChange={(e) => {
                            const localDate = e.target.value.split("-");
                            if (localDate) {
                              setDisputedRangeStart(
                                new Date(
                                  localDate[0],
                                  localDate[1] - 1,
                                  localDate[2]
                                )
                              );
                            }
                          }}
                        />
                      </Col>
                      <Col className="text-center">
                        Dispute Range End:{" "}
                        <input
                          type="date"
                          onChange={(e) => {
                            const localDate = e.target.value.split("-");
                            if (localDate) {
                              setDisputedRangeEnd(
                                new Date(
                                  localDate[0],
                                  localDate[1] - 1,
                                  localDate[2]
                                )
                              );
                            }
                          }}
                        />
                      </Col>
                    </Row>
                    <table className="table table-hover table-striped table-dark text-center">
                      <tr>
                        <th>Distributor</th>
                        <th># of Disputes</th>
                        <th>Total Disputed</th>
                        <th>Disputes Won</th>
                        <th>Disputes Won Total</th>
                        <th>Disputes Lost</th>
                        <th>Disputes Lost Total</th>
                      </tr>
                      {disputedDistributorReport.map((obj, key) => {
                        return (
                          <tr key={key}>
                            {Object.keys(obj).map((header, headerKey) => {
                              return <td key={headerKey}>{obj[header]}</td>;
                            })}
                          </tr>
                        );
                      })}
                      <tr
                        style={{
                          borderTop: "2px solid white",
                        }}
                      >
                        <th></th>
                        <th>{disputedDistributorNumOfDisputes}</th>
                        <th>{disputedDistributorTotalDisputedAmount}</th>
                        <th>{disputedDistributorNumOfWonDisputes}</th>
                        <th>{disputedDistributorTotalWonDisputedAmount}</th>
                        <th>{disputedDistributorNumOfLostDisputes}</th>
                        <th>{disputedDistributorTotalLostDisputedAmount}</th>
                      </tr>
                    </table>

                    <table className="table table-hover table-striped table-dark text-center">
                      <tr>
                        <th>Distributor</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Phone</th>
                        <th># of Disputes</th>
                        <th>Total Disputed</th>
                      </tr>
                      {disputedCustomerReport.map((obj, key) => {
                        return (
                          <tr key={key}>
                            <td>{obj.referenceid1}</td>
                            <td>{obj.firstname}</td>
                            <td>{obj.lastname}</td>
                            <td>{obj.phone}</td>
                            <td>{obj.numOfDisputes}</td>
                            <td>{obj.totalDisputedAmount}</td>
                          </tr>
                        );
                      })}
                      <tr
                        style={{
                          borderTop: "2px solid white",
                        }}
                      >
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th>{disputedCustomerNumOfDisputes}</th>
                        <th>{disputedCustomerTotalDisputedAmount}</th>
                      </tr>
                    </table>
                  </>
                )}

                {!customer && currentView === "latestDisputedTransactions" && (
                  <>
                    <Row>
                      <Dropdown isOpen={dropdownLatestOpen} toggle={toggle}>
                        <DropdownToggle>
                          {"Processor"} {" ("}
                          {disputedTransactionsOptions.gateway
                            ? disputedTransactionsOptions.gateway
                            : "All"}{" "}
                          {") "}
                          {dropdownLatestOpen ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-caret-up-fill"
                              viewBox="0 0 16 16"
                            >
                              <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" />
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-caret-down-fill"
                              viewBox="0 0 16 16"
                            >
                              <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                            </svg>
                          )}
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem
                            value={null}
                            onClick={(e) => {
                              setDisputedTransactionsOptions((prevState) => {
                                return {
                                  prevState,
                                  gateway: e.target?.value ?? null,
                                };
                              });
                            }}
                          >
                            All
                          </DropdownItem>
                          <DropdownItem
                            value="Square"
                            onClick={(e) => {
                              setDisputedTransactionsOptions((prevState) => {
                                return {
                                  prevState,
                                  gateway: e.target?.value ?? null,
                                };
                              });
                            }}
                          >
                            Square
                          </DropdownItem>
                          <DropdownItem
                            value="Stripe"
                            onClick={(e) => {
                              setDisputedTransactionsOptions((prevState) => {
                                return {
                                  prevState,
                                  gateway: e.target?.value ?? null,
                                };
                              });
                            }}
                          >
                            Stripe
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </Row>
                    <br />
                    <Row className="justify-content-center">
                      {allDisputedTransactions.length > 0 && (
                        <Col sm="12" className="customer-card">
                          <h5 className="section-heading">
                            Latest Disputed Transactions
                          </h5>
                          <XTable
                            columns={listHeader}
                            loading={false}
                            data={allDisputedTransactions}
                            filterbutton={false}
                          />
                        </Col>
                      )}
                    </Row>
                  </>
                )}

                {customer && (
                  <Row>
                    <Col lg="6" md="6" className="customer-card">
                      {customer.plaidverified ? (
                        <CustomerCard
                          customer={customer}
                          setCustomer={setCustomer}
                          lockNote={lockNote}
                          updateCustomerNotes={updateCustomerNotes}
                        />
                      ) : (
                        <CustomerCard
                          customer={customer}
                          setCustomer={setCustomer}
                          lockNote={lockNote}
                          setCustomerPlaidVerify={setCustomerPlaidVerify}
                          updateCustomerNotes={updateCustomerNotes}
                        />
                      )}
                    </Col>

                    {transactions.length > 0 && (
                      <Col lg="6" md="6" className="customer-card">
                        <h5 className="section-heading">
                          Disputed Transactions
                        </h5>
                        <XTable
                          columns={listHeader}
                          loading={false}
                          data={transactions}
                          filterbutton={false}
                        />
                      </Col>
                    )}
                  </Row>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default TransactionDisputeLookup;
